import { render } from "./AvaliacaoTrip.vue?vue&type=template&id=0ac9bda2&scoped=true&lang=pug"
import script from "./AvaliacaoTrip.vue?vue&type=script&setup=true&lang=js"
export * from "./AvaliacaoTrip.vue?vue&type=script&setup=true&lang=js"

import "./AvaliacaoTrip.vue?vue&type=style&index=0&id=0ac9bda2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac9bda2"]])

export default __exports__